import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipeUrl implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(url: string): SafeResourceUrl {
    const raw = environment.allowedIframeHosts ?? '';
    const defaultList = 'www.youtube.com,youtube.com,www.youtube-nocookie.com,youtube-nocookie.com,youtu.be';
    const allowedHosts = (raw.includes('__') ? defaultList : raw).split(',').map(s => s.trim()).filter(Boolean);
    try {
      const parsed = new URL(url);
      const isHttps = parsed.protocol === 'https:';
      const isAllowedHost = allowedHosts.some(h => parsed.hostname === h || parsed.hostname.endsWith('.' + h));
      if (isHttps && isAllowedHost) {
        // Safe: url validada (HTTPS + host en allowedIframeHosts); evita XSS
        return this.sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR
      }
    } catch {
      // URL inválida - evita XSS
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('about:blank'); // NOSONAR - URL literal segura
  }

}
